import { useEffect, useState } from 'react';

/** Format duration in ms as HH:MM:SS. */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  return [hours, mins, secs].map(n => n.toString().padStart(2, '0')).join(':');
}

/**
 * Live HH:MM:SS elapsed time since startTime, updating every second.
 * Returns '00:00:00' while startTime is null.
 */
export function useElapsed(startTime: number | null): string {
  const [elapsedMs, setElapsedMs] = useState(0);
  useEffect(() => {
    if (startTime == null) {
      setElapsedMs(0);
      return;
    }
    const tick = () => setElapsedMs(Math.max(0, Date.now() - startTime));
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [startTime]);
  return formatDuration(elapsedMs);
}
